import { useState } from 'react';

import { Card, Column, Row } from 'components/Blocks';

import { LogoWithText } from 'components/Logos';

import { EmailStep } from './EmailStep';
import { OTPStep } from './OTPStep';
import { TokenValidator } from './TokenValidator';
import { navigateToLogin } from 'providers/Auth';

export function ForgotPassword() {
  const [email, setEmail] = useState('');

  return (
    <Column fullHeight>
      <header className="bg-primary p-4">
        <Row className="mx-auto max-w-7xl">
          <button onClick={navigateToLogin}>
            <LogoWithText color="primary-foreground" />
          </button>
        </Row>
      </header>

      <Column className="px-4" justifyContent="center" fullHeight>
        <Card className="mx-auto w-[min(90vw,460px)] p-6 text-center" variant="shadow">
          <TokenValidator>
            {email ? <OTPStep email={email} /> : <EmailStep onEmail={setEmail} />}
          </TokenValidator>
        </Card>
      </Column>
    </Column>
  );
}
